import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';
import { isEmpty } from 'lodash';
import { Form, Segment, Message } from 'semantic-ui-react';
import DealerList from '../views/DealerQuote/List';
import ResendEmail from '../views/DealerQuote/ResendEmail';

const DealerQuote = props => {
  const {
    enrollmentStatus,
    localDealerNo,
    onSearchSubmitHandler,
    auctionAccessNumber,
    onChangeHandler,
    showProductSelection,
    addDealerHandler,
    displayDealerConfirm,
  } = props;

  const [modalOpen, setModalOpen] = useState(false);
  const [incompleteEnrollment, setIncompleteEnrollment] = useState('');
  const [flashMessage, setFlashMessage] = useState(null);
  const [error, setError] = useState(null);

  const isUpgradeAvailable = useCallback(enrollment => {
    if (!enrollmentStatus || !enrollmentStatus.eligibleOffers) return false;
    const offers = enrollmentStatus.eligibleOffers.filter(
      offer => offer.dealerNo === enrollment.dealerNo
        && offer.productId !== enrollment.productId
    );
    return offers.length > 0;
  }, [enrollmentStatus]);

  const isAllOffersZero = useCallback(enrollment => {
    if (!enrollmentStatus || !enrollmentStatus.eligibleOffers) return false;
    const offers = enrollmentStatus.eligibleOffers.filter(
      offer => offer.dealerNo === enrollment.dealerNo
        && offer.incompleteEnrollment === null
        && offer.rate === 0
    );
    if (offers.length > 0) return true;
    if (enrollment.rate === 0) return true;
    return false;
  }, [enrollmentStatus]);

  const handleOpen = useCallback(incEnrollment => {
    setModalOpen(true);
    setIncompleteEnrollment(incEnrollment);
    setFlashMessage(null);
    setError(null);
  }, []);

  const flashMessageSuccess = useCallback(() => {
    setFlashMessage('mail sent successfully');
  }, []);

  const flashMessageFailure = useCallback(err => {
    setError(err);
  }, []);

  const flashMessageClear = useCallback(() => {
    setFlashMessage(null);
  }, []);

  const handleClose = useCallback(() => {
    setModalOpen(false);
  }, []);

  return (
    <div className='dealer-enrollment'>
      {error && (
        <Message negative>
          <p>{error}</p>
        </Message>
      )}

      {flashMessage && (
        <Message
          onDismiss={flashMessageClear}
          content={flashMessage}
          positive
        />
      )}

      <Segment placeholder>
        <Form>
          <Form.Group widths='two'>
            <Form.Input
              name='auctionAccessNumber'
              placeholder=' 100M'
              value={auctionAccessNumber}
              onChange={onChangeHandler('auctionAccessNumber')}
            />
            <Form.Button
              color='green'
              onClick={() => {
                onSearchSubmitHandler();
                flashMessageClear();
              }}
              inverted
              disabled={isEmpty(auctionAccessNumber)}
            >
              Search
            </Form.Button>
          </Form.Group>
        </Form>
      </Segment>
      {enrollmentStatus && (
        <div>
          <DealerList
            dealerDetails={enrollmentStatus}
            showProductSelection={showProductSelection}
            isUpgradeAvailable={isUpgradeAvailable}
            onChangeHandler={onChangeHandler}
            addDealerHandler={addDealerHandler}
            localDealerNo={localDealerNo}
            displayDealerConfirm={displayDealerConfirm}
            handleOpen={handleOpen}
            isAllOffersZero={isAllOffersZero}
          />
          {modalOpen && (
            <div>
              <ResendEmail
                modalOpen={modalOpen}
                handleClose={handleClose}
                enrollmentStatus={enrollmentStatus}
                incompleteEnrollment={incompleteEnrollment}
                flashMessageSuccess={flashMessageSuccess}
                flashMessageFailure={flashMessageFailure}
              />
            </div>
          )}
        </div>
      )}

      {enrollmentStatus
        && isEmpty(enrollmentStatus.enrollments) && (
          <Message content='Invalid HundredMil' negative />
      )}
    </div>
  );
};

DealerQuote.propTypes = {
  enrollmentStatus: PropTypes.shape({
    eligibleOffers: PropTypes.array,
    enrollments: PropTypes.array,
  }),
  localDealerNo: PropTypes.string,
  onSearchSubmitHandler: PropTypes.func.isRequired,
  auctionAccessNumber: PropTypes.string,
  onChangeHandler: PropTypes.func.isRequired,
  showProductSelection: PropTypes.func.isRequired,
  addDealerHandler: PropTypes.func.isRequired,
  displayDealerConfirm: PropTypes.func.isRequired,
};

DealerQuote.defaultProps = {
  enrollmentStatus: null,
  localDealerNo: '',
  auctionAccessNumber: '',
};

export default compose(withRouter)(DealerQuote);
